export enum Name {
    V1database = 'v1-database',
    V1deletes = 'v1-deletes',
    V1audits = 'v1-audits',
    V1mails = 'v1-mails',
    V1functions = 'v1-functions',
    V1statsresources = 'v1-stats-resources',
    V1statsusage = 'v1-stats-usage',
    V1webhooks = 'v1-webhooks',
    V1certificates = 'v1-certificates',
    V1builds = 'v1-builds',
    V1screenshots = 'v1-screenshots',
    V1messaging = 'v1-messaging',
    V1migrations = 'v1-migrations',
}